import * as R from 'ramda';
import { Map, List, isImmutable } from 'immutable';
import actions from '../store/actions';
import { is, reduceWhile } from 'ramda';
import { SERVICE_TYPE_PER_PERSON, SERVICE_TYPE_PER_PERSON_NIGHT } from '../config/constants';
import { get } from '@synergycms_core/utils';
import { DISCOUNT_FLEX_RATE, PROPERTY_MANAGEMENT_GROUP } from '../config/constants';
import moment from 'moment';
import format from 'string-template';
import { keyIn, getPrice, formatCurrencyAmount } from '@synergycms_core/utils/utils';
import { contentGetter } from '@synergycms_core/content/i18n';

const {
  currentHotel: currentHotelAction,
  params: paramsAction,
  reservationRequest: reservationRequestAction,
  roomPreferences: roomPreferencesActions,
  ipCountry: ipCountryActions,
  loyalty:loyaltyActions
} = actions.customer;

const availCalendarActions = actions.availCalendar;
const availActions = actions.avail;
const availServicesActions = actions.availServices;
const availCacheActions = actions.availCache;


export const getTranslation = (langs, entity, fields, defaultText) => {
  langs = !R.contains('en', langs) ? langs.push('en') : langs;
  if (isImmutable(entity)) {
    if (entity.get('translations')) {
      const translation = entity.get('translations');
      return (
        R.reduceWhile(
          value => !value,
          (acc, lang) => {
            return R.reduceWhile(
              value => !value,
              (acc, field) => {
                return translation.getIn([lang, field]);
              },
              null,
              fields
            );
          },
          null,
          langs
        ) || defaultText
      );
    }
  } else if (is(Object, entity)) {
    if (entity.translations) {
      const translations = entity.translations;
      return (
        R.reduceWhile(
          value => !value,
          (acc, lang) => {
            return R.reduceWhile(
              value => !value,
              (acc, field) => {
                return get([lang, field], translations);
              },
              null,
              fields
            );
          },
          null,
          langs
        ) || defaultText
      );
    }
  } else {
    return defaultText;
  }
};

export const updateIn = R.curry((path, val, obj) =>
  R.compose(
    R.set(R.__, val, obj),
    R.apply(R.compose),
    R.map(R.cond([[R.is(Number), R.lensIndex], [R.T, R.lensProp]]))
  )(path)
);

/**
 *
 * @param number
 * @param decimals
 * @returns {number}
 */
export const round = (number, decimals = 2) => Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);

/**
 *
 * @param input
 * @returns {string}
 */
export const lowerFirst = input => input.charAt(0).toLowerCase() + input.substring(1, input.length);

/**
 *
 * @param cityLat
 * @param cityLon
 * @param hotelLat
 * @param hotelLon
 * @returns {number}
 */
export const getDistance = function (cityLat, cityLon, hotelLat, hotelLon) {
  cityLat = parseFloat(cityLat);
  cityLon = parseFloat(cityLon);
  hotelLat = parseFloat(hotelLat);
  hotelLon = parseFloat(hotelLon);
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(hotelLat - cityLat); // deg2rad below
  const dLon = deg2rad(hotelLon - cityLon);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(cityLat)) * Math.cos(deg2rad(hotelLat)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in km
};

/**
 *
 * @param deg
 * @returns {number}
 */
const deg2rad = function (deg) {
  return deg * (Math.PI / 180);
};

/**
 *
 * @param number
 * @param decPlaces
 * @param thouSeparator
 * @param decSeparator
 * @returns {string}
 */
export const formatNumber = (number, decPlaces, thouSeparator, decSeparator) => {
  decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces;
  thouSeparator = thouSeparator === undefined ? ',' : thouSeparator;
  decSeparator = decSeparator === undefined ? '.' : decSeparator;
  const sign = number < 0 ? '-' : '';
  const i =
    parseInt((number = Number(Math.round(Math.abs(+number || 0) + 'e' + decPlaces) + 'e-' + decPlaces)), 10) + '';
  const j = i.length > 3 ? i.length % 3 : 0;
  return (
    sign +
    (j ? i.substr(0, j) + thouSeparator : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thouSeparator) +
    (decPlaces
      ? decSeparator +
      Number(Math.round(Math.abs(number - i) + 'e' + decPlaces) + 'e-' + decPlaces)
        .toFixed(decPlaces)
        .slice(2)
      : '')
  );
};

/**
 * Funció que chequeja si hi ha algun segment sense dispo o per cas contrari tots en tenen
 * @param roomsAvail
 * @param flexible
 * @returns {boolean}
 */
export const checkAvailSegments = (roomsAvail, flexible = false) => {
  //let success = !(!roomsAvail || roomsAvail.get('success') === false);

  let success = roomsAvail && roomsAvail.every((refTypeGroup,idx) => {
    return idx % 2 !== 0 || refTypeGroup.get('success');
  });

  success = success && !roomsAvail.groupBy((refs) => {
    return refs && refs.get("occup_group_id");
  }).valueSeq().find((roomAvailOccup) => {
    const segments = roomAvailOccup.size / (flexible ? 1 : 2);
    let totalQuotas = Map();
    if (segments > 1) {
      roomAvailOccup.getIn([0, 'rooms'], List()).forEach(room => {
        room.get('days', List()).forEach(day => {
          totalQuotas = totalQuotas.set(
            day.get('day'),
            totalQuotas.get(day.get('day'), 0) + day.getIn(['boards', 0, 'quota'], 0)
          );
        });
      });
      return totalQuotas.every(value => {
        return value < segments;
      });
    }
    return false;
  });


  return success;
};

/**
 *
 * @param bookingBlocks
 * @returns {*}
 */
export const getSegmentsFilled = bookingBlocks => {
  return bookingBlocks.reduce((segmentsFilled, block) => {
    return block.has('room_id') ? segmentsFilled + 1 : segmentsFilled + 0;
  }, 0);
};


/**
 *
 * @param objectMap
 * @returns {function(...[*]): *}
 */
export const immutablePick = objectMap => (...keys) => objectMap.filter(keyIn(...keys));



/**
 *
 */
export const splice = (input, start, delCount, newSubStr) => {
  return input.slice(0, start) + newSubStr + input.slice(start + Math.abs(delCount));
};

/**
 *
 * @param store
 * @returns {Map<any, any>|Map<string, number>}
 */
export const getReservationTotals = (store, forceTaxes = false, customBlocks = false) => {
  let totalPrice = 0;
  let roomsPrice = 0;
  let servicesPrice = 0;
  let totalDiscount = 0;

  const hotelId = store.getIn(['customer', 'current_hotel']);
  const showTaxes = forceTaxes || store.getIn(['hotels', hotelId, 'show_taxes']);
  const reservationBlocks = customBlocks || store.getIn(['customer', 'reservation_request', 'blocks']);
  const hotelAvail = store.getIn([
      'avail',
      hotelId,
      store.getIn(['hotels', hotelId, 'params', reservationAvailQuery(store).get("string_params")]),
      'response'
    ]);
  const servicesAvail = store.getIn([
      'availServices',
      hotelId,
      store.getIn(['hotels', hotelId, 'params', 'string_service_query_params']),
      'response',
      'services'
    ]);
  if (hotelAvail) {
    reservationBlocks.forEach(block => {
      const roomPrice = showTaxes ? block.get('price_tax') : block.get('price');
      totalDiscount += Math.abs(block.get('discount_amount'));

      const blockServiceId = block.get('service_id', false);

      block.get('services').forEach(service => {
        const serviceId = service.get('service_id');
        if (serviceId) {
          const serviceInfo = servicesAvail.find(availService => availService.get('id') === serviceId);
          if(serviceInfo) {
            const serviceType = serviceInfo.get('type').toUpperCase();

            if (!parseInt(blockServiceId, 10) > 0 || blockServiceId !== serviceId) {

              let servicePrice;
              if(serviceInfo.get('works_with_quota', false)) {
                if(service.get('dates', List()).size) {
                  servicePrice = service.get('dates', List()).reduce((acc, date) => {
                    let dayPrice = serviceInfo.get('days', List()).find(day => day.get('day') === date.get('day'));
                    let quantity = date.get('quantity');
                    if(serviceType === SERVICE_TYPE_PER_PERSON || serviceType === SERVICE_TYPE_PER_PERSON_NIGHT) {
                      if (serviceInfo.get('has_price_per_child', false)) {
                        const serviceChildPrice = showTaxes ? serviceInfo.get('child_price_tax') : serviceInfo.get('child_price');
                        const adultDayPrice = showTaxes ? dayPrice.get('price_tax') : dayPrice.get('price');
                        const roomAvail = hotelAvail.getIn([block.get('idx') - 1, block.get('room_id').toString()]);
                        const adultOccupants = parseInt(roomAvail.get('adults', 0));
                        const childOccupants = parseInt(roomAvail.get('childs', 0));

                        return acc + (adultDayPrice * adultOccupants + (serviceChildPrice * childOccupants));
                      } else {
                        quantity = parseInt(block.get('adults', 0)) + parseInt(block.get('childs', 0));
                        return acc + (showTaxes ? dayPrice.get('price_tax') : dayPrice.get('price')) * quantity;
                      }
                    } else {
                      return acc + (showTaxes ? dayPrice.get('price_tax') : dayPrice.get('price')) * quantity;
                    }
                  }, 0);
                } else {
                  servicePrice = (showTaxes ? serviceInfo.get('price_tax') : serviceInfo.get('price')) * service.get('quantity');
                }
              } else {
                servicePrice =
                  (showTaxes ? serviceInfo.get('price_tax') : serviceInfo.get('price')) * service.get('quantity');
              }

              if (serviceType === SERVICE_TYPE_PER_PERSON || serviceType === SERVICE_TYPE_PER_PERSON_NIGHT) {
                if(!serviceInfo.get('works_with_quota', false)) {
                  const roomAvail = hotelAvail.getIn([block.get('idx') - 1, block.get('room_id').toString()]);
                  const adultOccupants = parseInt(roomAvail.get('adults', 0));
                  const childOccupants = parseInt(roomAvail.get('childs', 0));
                  if (serviceInfo.get('has_price_per_child', false)) {
                    const serviceChildPrice = showTaxes ? serviceInfo.get('child_price_tax') : serviceInfo.get('child_price');
                    servicePrice = (servicePrice * (adultOccupants) + (serviceChildPrice * childOccupants));
                  } else {
                    servicePrice = servicePrice * (adultOccupants + childOccupants);
                  }
                }
              }

              servicesPrice = servicesPrice + servicePrice;
              totalPrice = totalPrice + servicePrice;
            }
          }
        }
      });

      roomsPrice = roomsPrice + roomPrice;
      totalPrice = totalPrice + roomPrice;
    });
  }
  return Map({
    rooms_price: roomsPrice,
    services_price: servicesPrice,
    total_price: totalPrice,
    discount_amount: totalDiscount,
    discount_percent: round((totalDiscount * 100) / (totalPrice + totalDiscount), 0)
  });
};

/**
 *
 * @param dispatch
 * @param hotelId
 * @param hotelCode
 * @param rate
 */
export const goForwardMultiHotelAvail = (dispatch, hotelId, hotelCode, customParams = false ) => {
  
  //ACTIVE LOYALTY
  dispatch(currentHotelAction.set(hotelId));
  dispatch(paramsAction.updateParams(Map({ hotelId: hotelId })));

  let props = {
     avail : dispatch(loyaltyActions.loyaltyAsync()).then(()=> dispatch(availActions.getAvailAsync(false,'loyalty'))),
      services : dispatch(availServicesActions.getAsync()),
      loyalty : dispatch(loyaltyActions.loyaltyAsync()).then(()=> {
        dispatch(availActions.getAvailAsync(false,'loyalty')).then(()=>{
          dispatch(availActions.getAvailParsed())
        })
      })
  }

  if(customParams) {
    const start = moment(customParams.params.get('start'));
    customParams.params = customParams.params.delete('start');

    const end = moment(customParams.params.get('end'));
    customParams.params = customParams.params.delete('end');

    props.availCache = dispatch(availCacheActions.getAsync(
      start, 
      end, 
      customParams
    ));
  }


  Promise.props(props).then(() => {
      dispatch(reservationRequestAction.initialize());
      dispatch(actions.customer.step.next());
      dispatch(availActions.getAvailParsed());
      dispatch(roomPreferencesActions.initialize());
      dispatch(availCalendarActions.getAsync());
      dispatch(ipCountryActions.getAsync());
      dispatch(actions.router.update());
      dispatch(actions.customer.header.show('engine', false));
      const idHotelInput = document.getElementById('id_hotel');

      if (idHotelInput !== null && typeof window.showNotifications === 'function') {
        document.getElementById('id_hotel').value = hotelCode;
        window.showNotifications();
      }
    });
};

/**
 * Funcio per recuperar les diferencies entre 2 objectes, perfecte per controlar els canvis a les props i refresh de components
 * @param {*}
 * @param {*}
 * @returns {*}
 */

const isObject = R.compose(
  R.equals('Object'),
  R.type
);
const allAreObjects = R.compose(
  R.all(isObject),
  R.values
);
const hasLeft = R.has('left');
const hasRight = R.has('right');
const hasBoth = R.both(hasLeft, hasRight);
const isEqual = R.both(
  hasBoth,
  R.compose(
    R.apply(R.equals),
    R.values
  )
);

const markAdded = R.compose(
  R.append(undefined),
  R.values
);
const markRemoved = R.compose(
  R.prepend(undefined),
  R.values
);
const isAddition = R.both(hasLeft, R.complement(hasRight));
const isRemoval = R.both(R.complement(hasLeft), hasRight);

export const objectDiff = R.curry(_diff);

function _diff(l, r) {
  return R.compose(
    R.map(
      R.cond([
        [isAddition, markAdded],
        [isRemoval, markRemoved],
        [
          hasBoth,
          R.ifElse(
            allAreObjects,
            R.compose(
              R.apply(objectDiff),
              R.values
            ),
            R.values
          )
        ]
      ])
    ),
    R.reject(isEqual),
    R.useWith(R.mergeWith(R.merge), [R.map(R.objOf('left')), R.map(R.objOf('right'))])
  )(l, r);
}

export const dispatchEvent = (name, detail) => {
  const event = new CustomEvent(name, { detail });
  document.dispatchEvent(event);
};

export const parseServices = (hotelInfo, reservationBlocks, hotelAvail, serviceAvailResponse, grupedByBlock = false) => {
  if (reservationBlocks && hotelAvail) {
    let parsedServices = reservationBlocks.reduce((services, block) => {
      const blockServiceId = block.get('service_id');
      block.get('services').forEach(service => {

        const serviceId = service.get('service_id', false);

        if (serviceId) {

          const serviceKey = services.findIndex(s => serviceId === s.get('service_id'));
          const serviceInfo = serviceAvailResponse.get('services').find(availService => availService.get('id') === serviceId);

          if (serviceInfo) {

            let servicePrice = calculateServicePrice(serviceInfo, service, hotelInfo, block, hotelAvail);

            if (!parseInt(blockServiceId, 10) > 0 || blockServiceId !== serviceId) {
              const key = service.get('dates', false) ? 'dates' : 'days';
              if (service.get(key, List()).size) {
                service.get(key, List()).forEach(date => {

                  let momentDate = moment(date.get('day'));
                  let formattedDate = momentDate.format('D MMMM');

                  if (date.get('time', false)) {
                    momentDate = momentDate.add(moment(date.get('time'), 'HH:mm:ss').get('hour'), 'hour');
                    formattedDate = momentDate.format('D MMMM - HH:mm') + " h";
                  }

                  const dateTimeIdx = services.findIndex(s => {
                    return s.get('service_id') === service.get('service_id') && s.get('stringDate') === formattedDate;
                  });

                  let dayTimePrice = serviceInfo.get('days', List()).find(day => day.get('day') === date.get('day'));
                  servicePrice = calculateServicePrice(serviceInfo, date, hotelInfo, block, hotelAvail, dayTimePrice);

                  if (dateTimeIdx !== -1) {
                    if(grupedByBlock) {
                      services = services.push(Map({
                        service_id: service.get('service_id'),
                        quantity: date.get('quantity'),
                        price: servicePrice,
                        stringDate: formattedDate,
                        momentDate: momentDate,
                        blockIdx: block.get('idx'),
                      }));
                    } else {
                      let newService = services.get(dateTimeIdx);
                      services = services.delete(dateTimeIdx);

                      newService = newService.set('quantity', newService.get('quantity') + date.get('quantity'))
                                             .set('blockIdx', block.get('idx'))
                                             .set('price', newService.get('price') + servicePrice)
                                             .set('momentDate', momentDate);

                      services = services.push(newService);
                    }
                  } else {
                    services = services.push(Map({
                      service_id: service.get('service_id'),
                      quantity: date.get('quantity'),
                      price: servicePrice,
                      stringDate: formattedDate,
                      momentDate: momentDate,
                      blockIdx: block.get('idx'),
                    }));
                  }

                });
              } else {
                if (serviceKey !== -1) {
                  services = services
                    .setIn([serviceKey, 'blockIdx'], block.get('idx'))
                    .setIn([serviceKey, 'quantity'], service.get('quantity') + services.getIn([serviceKey, 'quantity']))
                    .setIn([serviceKey, 'price'], servicePrice + services.getIn([serviceKey, 'price']));
                } else {
                  services = services.push(service.set('price', servicePrice).set('blockIdx', block.get('idx')));
                }
              }

            }
          }
        }

      });
      return services;
    }, List());

    parsedServices = parsedServices.sort((a, b) => {
      if (!a.get('momentDate')) {return -1;}
      if (!b.get('momentDate')) {return 1;}
      return a.get('momentDate').isBefore(b.get('momentDate')) ? -1 : 1;
    });

    return parsedServices;
  }
};

const calculateServicePrice = (serviceInfo, service, hotelInfo, block, hotelAvail, dayTimePrice = null) => {
  const serviceType = serviceInfo.get('type').toUpperCase();

  let servicePrice;
  if(dayTimePrice) {
    servicePrice = (hotelInfo.get('show_taxes') ? dayTimePrice.get('price_tax') : dayTimePrice.get('price')) * service.get('quantity');
  } else {
    servicePrice = (hotelInfo.get('show_taxes') ? serviceInfo.get('price_tax') : serviceInfo.get('price')) * service.get('quantity');
  }

  if (serviceType === SERVICE_TYPE_PER_PERSON || serviceType === SERVICE_TYPE_PER_PERSON_NIGHT) {
    const roomAvail = hotelAvail.getIn([block.get('idx') - 1, block.get('room_id').toString()]);
    const adultOccupants = parseInt(roomAvail.get('adults', 0));
    const childOccupants = parseInt(roomAvail.get('childs', 0));
    const totalOccupants = adultOccupants + childOccupants

    if (serviceInfo.get('has_price_per_child', false)) {

      let servicePriceChild;
      let servicePriceAdult;
      if(hotelInfo.get('show_taxes')) {
        servicePriceChild = service.get('child_price_tax', 0);
        servicePriceAdult = (dayTimePrice ? dayTimePrice.get('price_tax') : serviceInfo.get('price_tax'));
      } else {
        servicePriceChild = service.get('child_price', 0);
        servicePriceAdult = (dayTimePrice ? dayTimePrice.get('price') : serviceInfo.get('price'));
      }

      servicePrice = (servicePriceAdult * adultOccupants) + (servicePriceChild * childOccupants);

    } else {
      if(hotelInfo.get('show_taxes')) {
        servicePrice = (dayTimePrice ? dayTimePrice.get('price_tax') : serviceInfo.get('price_tax')) * totalOccupants;
      } else {
        servicePrice = (dayTimePrice ? dayTimePrice.get('price') : serviceInfo.get('price')) * totalOccupants;
      }
    }
  }

  return servicePrice;
};

export const isRefundable = (
  hotelAvail,
  reservationBlocks,
  parsedServices,
  serviceAvailResponse,
  managementGroupID,
  fromStorage = false
) => {
  let refundable = true;
  if (reservationBlocks && is(List, hotelAvail) && hotelAvail.size > 0 && hotelAvail) {
    hotelAvail.keySeq().forEach(key => {
      const block = reservationBlocks.get(key, false);
      if(block) {
        const roomId = fromStorage ? block.get('room_id').toString() : block.get('room_id');
        const serviceId = block.get('service_id');
        const boardId = fromStorage ? block.get('board_id').toString() : block.get('board_id');
        const roomAvail = hotelAvail && hotelAvail.getIn([key, serviceId ? roomId + '-' + serviceId : roomId]);
        const boardAvail = roomAvail && roomAvail.getIn(['boards', boardId, block.get('ref_type')]);
        const firstDay = boardAvail && boardAvail.get('days').first();
        const flexDiscount = (boardAvail && boardAvail.get('discounts', List()).find(d => (d.get('acronym', '') || '').indexOf(DISCOUNT_FLEX_RATE) === 0)) || false;
        let flexDiscountNew = (boardAvail && boardAvail.get('discounts', List()).find(d => d.get('flexible', false))) || false;
        if (!flexDiscountNew) {
          flexDiscountNew = firstDay && firstDay.get('flexible', false) && firstDay;
        }
        if (!(flexDiscountNew && flexDiscountNew.get('flexible_release', 0) > 0)) {
          flexDiscountNew = false;
        }

        if (flexDiscount && PROPERTY_MANAGEMENT_GROUP !== managementGroupID && !boardAvail.get('refundable', false)) {
          const daysRelease = flexDiscount ? flexDiscount.get('acronym').split(DISCOUNT_FLEX_RATE)[1] : 0;
          const releaseDay = moment(boardAvail.get('days').keySeq().first()).subtract(daysRelease, 'd');
          const daysDiff = releaseDay.diff(moment(), 'd', true);
          const applyPenaltyRelease = daysDiff <= 0;
          refundable = refundable && !applyPenaltyRelease;
        } else {
          refundable = refundable && boardAvail && boardAvail.get('refundable', false) === true && !flexDiscount && !flexDiscountNew;
        }
      }
    });

    parsedServices.keySeq().forEach(key => {
      const service = parsedServices.get(key),
        serviceInfo = serviceAvailResponse
          .get('services')
          .find(availService => +availService.get('id') === +service.get('service_id'));
      if (!serviceInfo.get('has_closed_price', false)) {
        refundable = refundable && serviceInfo.get('refundable', false) === true;
      }
    });
  }

  return reservationBlocks ? refundable : undefined;
};

export const reduceWhileResolved = (store, storeKey, hotelsIds = null) => {
  hotelsIds = hotelsIds || store.getIn(['customer', 'current_hotels']);

  const itemsResolveds = reduceWhile(
    (itemsResolveds, hotelId) => {
      if (storeKey === 'hotels') {
        return is(Boolean, store.getIn([storeKey, hotelId, 'success']));
      } else {
        const baseParams = store.getIn(['customer', 'params', store.getIn(["availQuery", "multi", "params"])], undefined);
        const hotelParams = store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "multi", "base"])], undefined);

        if(!baseParams || !hotelParams || !hotelParams.includes(baseParams)) return false;

        //console.log("Query", hotelId);
        const queryParams = store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "multi", "string_params"])]);
        //console.log("all query params",store.getIn(['hotels', hotelId, 'params'])?.toJS());
        //console.log("queryParams",queryParams);
        //console.log("has avail?", store.getIn([storeKey, hotelId, queryParams])?.toJS());
        //console.log("avail", store.getIn([storeKey, hotelId])?.toJS());
        return store.getIn([storeKey, hotelId, queryParams, 'raw_response']);
      }
    },
    (itemsResolveds, hotelId) => itemsResolveds.set(hotelId, store.getIn([storeKey, hotelId])),
    new Map(),
    hotelsIds
  );
  return hotelsIds.size > 0 && hotelsIds.size === itemsResolveds.size ? itemsResolveds : undefined;
};

export const cleanHotelPreferences = hotelPreferences =>
  hotelPreferences.reduce((preferences, preference) => {
    if (preference.get('options').size > 0) {
      return preferences.push(preference);
    } else {
      return preferences;
    }
  }, List());

export const addScripts = (hotelDetails, referer, step) => {
  const scripts = hotelDetails.getIn(['extended_scripts'], undefined);

  if (scripts.size > 0 && referer) {
    scripts.forEach(scriptValues => {
      if (scriptValues.getIn(['referer']) === referer) {
        const existElement = document.getElementById(referer);
        const location = scriptValues.getIn(['location'], undefined);
        const showScript = location && location.includes(step);
        const existScript = scriptValues.getIn(['script'], undefined);
        if (!existElement && showScript) {
          if (existScript) {
            const script = document.createElement('div');
            script.innerHTML = existScript;
            let cloneScript = document.createElement("script");
            cloneScript.id = referer;
            let node = script.firstChild;
            node.attributes.forEach(function (element) {
              cloneScript.setAttribute(element.name, element.value);
            });
            document.body.appendChild(cloneScript);
          }
        }
        else if (existElement && !showScript) {
          document.getElementById(referer).remove();
        }
      }
    });
  }
};

export const getPrepaymentText = (
  requiredPrepayment,
  requiredPrepaymentValue,
  requiredPrepaymentType,
  currencies,
  currentCurrencyCode,
  hotelCurrencyCode,
  langInfo,
  content,
  forceHotelCurrency = false
) => {
  const currentCurrency = currencies.find(c => c.get('code') === currentCurrencyCode);
  const hotelCurrency = currencies.find(c => c.get('code') === hotelCurrencyCode);

  let translationType = '';
  switch (requiredPrepaymentType) {
    case 'percentage':
      translationType = content.t('del {prepayment_value}% del total de la reserva');
      translationType = format(translationType, { prepayment_value: requiredPrepaymentValue });
      break;
    case 'nights':
      translationType = content.t('de {prepayment_value} noches');
      translationType = format(translationType, { prepayment_value: requiredPrepaymentValue });
      break;
    default:
      if (!forceHotelCurrency && hotelCurrency && hotelCurrency.get('code') !== currentCurrency.get('code')) {
        requiredPrepayment = getPrice(requiredPrepayment, hotelCurrency.get('ratio'), currentCurrency.get('ratio'));
      }
      requiredPrepayment = formatCurrencyAmount(currencies, currentCurrency, langInfo)(requiredPrepayment, currentCurrency.get('code'), currentCurrency.get('decimals'));
      translationType = content.t('de {prepayment_value}');
      translationType = format(translationType, { prepayment_value: requiredPrepayment });
      break;
  }

  return format(content.t('Se solicita prepago {prepayment_type} para la confirmaci\u00f3n de esta reserva.'), { prepayment_type: translationType });
};

export const isIE = () => {
  // IE 10 and IE 11
  return /Trident\/|MSIE/.test(window.navigator.userAgent);
};


export const reservationAvailQuery = store => {
  //reservationAvailQuery(store).get("string_params")
  let prefix = "";
  if(store.getIn(['customer', 'rate_selected']) === 'loyalty') {
    prefix = "loyalty_";
  }

  return Map({
    base :`base_string_${prefix}query_params`,
    params :`${prefix}query_params`,
    string_params :`string_${prefix}query_params`,
    params_service :`service_${prefix}query_params`,
    string_service :`string_service_${prefix}query_params`,
    params_calendar :`calendar_${prefix}query_params`,
    string_calendar :`string_calendar_${prefix}query_params`,
    base_params_calendar :`base_calendar_${prefix}query_params`,
    base_string_calendar :`base_string_calendar_${prefix}query_params`,
  });
};

export const parseTaxes =  (hotel, reservationObj, mode = "default") => {
  const blocks = reservationObj && reservationObj?.get('blocks');
  const localTaxes = hotel && hotel?.get('localTaxes');
  const rates = reservationObj && reservationObj?.get('rates');
  const hotelTaxes = hotel && hotel?.get('taxes', false);
  const showTaxes = hotel && hotel?.get('show_taxes', false);

  // Calculamos el valor de los impuestos de las tarifas
  let rateTaxes = calculateRateTaxes(rates, hotelTaxes, blocks);

  // Calculamos valor de los impuestos locales y de los servicios
  let localTaxesBlocks = blocks.size > 0 ? Object.values(blocks.reduce((acc, block) => {
    acc = calculateLocalTaxes(block, acc, localTaxes);
    
    if(mode === "complete"){
      acc = calculateServicesTaxes(block, acc, showTaxes);
    }
    
    return acc;
  }, {})) : [];

  localTaxesBlocks = Object.values(rateTaxes).concat(localTaxesBlocks);

  let accumulator = {
    "included": [],
    "nonIncluded": []
  }

  return localTaxesBlocks.reduce(function(acc, tax) {
    if((tax.include_total_price && showTaxes )|| (tax.isRateTax && showTaxes) || (tax.isServiceTax && showTaxes)) {
      acc["included"].push(tax)
    } else {
      tax.name && acc['nonIncluded'].push(tax);
    }
    return acc;
  }, accumulator);

};

const calculateRateTaxes = (rates, hotelTaxes, blocks) => {

  let rateTaxes = rates.size > 0 ? rates.reduce((acc, rate) => {
    let hotelTax = hotelTaxes && hotelTaxes.find((tax) => tax.get("id") === rate.get('tax_id'));
    let hotelTaxInfo = hotelTax && hotelTax?.get('info');

    hotelTaxInfo && acc.push({
      is_percent: hotelTaxInfo.first().get('is_percent'),
      value: hotelTaxInfo.first().get('amount'),
      name: 'iva',
      isRateTax: true,
      tax_amount: blocks.reduce((sum, block) => {
        if(!block.get('rates', List()).size) return sum;
        return block.get('rates', List())._includes(parseInt(rate.get('id'))) ? sum + block.get('tax_amount') : sum;
      }, 0),
      include_total_price: rate.get('taxes_included')
    });
    return acc;
  }, []) : [];

  return rateTaxes.reduce((acc, tax) => {
    const key = `${tax.value}-${tax.is_percent}`;
    if (acc[key]) {
      acc[key].tax_amount += tax.tax_amount;
    } else {
      acc[key] = tax;
    }
    return acc;
  }, []);

}

const calculateLocalTaxes = (block, acc, localTaxes) => {
  let taxes = block.get('local_taxes');
  if(!taxes.size) return acc;

  taxes.forEach((tax) => {
    let taxId = tax.get('id');
    if(acc[taxId]) {
      acc[taxId].tax_amount += tax.get('tax_amount');
    } else {
      acc[taxId] = tax.toJS();
      Object.assign(acc[taxId], localTaxes.toJS().find(({id}) => id === taxId));
    }
  });
  return acc;
}

const calculateServicesTaxes = (block, acc, taxesIncluded) => {
  let blockServices = block.get('services', List());

  if(!blockServices.size) return acc;

  blockServices.forEach((service) => {

    const serviceKey = `srv-${service.get('tax_percent')}-${taxesIncluded ? 'included' : 'nonIncluded'}`;

    if(service.get('price_tax') <= 0) return acc;

    if(acc[serviceKey]) {
      acc[serviceKey].tax_amount += getServiceTaxAmount(block, service);
    } else {
      acc[serviceKey] = {
        is_percent: service.get('tax_percent'),
        value: service.get('tax_percent'),
        name: 'iva extras',
        isServiceTax: true,
        tax_amount: getServiceTaxAmount(block, service),
        include_total_price: service.get('taxes_included', false)
      };
    }

  });

  return acc;
};

export const getTaxText = (tax, mode = "default") => {

  if(tax.isRateTax) {
    return mode === 'default' ? 
      '_%iva%_': '_%iva_habitaciones%_';
  }

  if(tax.isServiceTax) {
    return '_%iva_extras%_'
  }

  return  `${tax.name}`
}

export const getServiceTaxAmount = (block, service) => {
  const type = service.get('type', '');
  const occupants = block.get('adults', 0) + block.get('childs', 0);
  const serviceQuantity = service.get('quantity', 0);
  const taxAmount = service.get('tax_amount', 0);

  switch(type) {
    case 'person':
    case 'person_night':
      return taxAmount * occupants;
    case 'use':
        return  taxAmount * serviceQuantity;
    case 'stay':
    default:
      return taxAmount;
  }

}

export const concatChildAgeText = ({childsInfo, separator = "_%y%_"}) => {

  const i18n = contentGetter();
  const count = childsInfo?.size;
  let childYears = "";
  if(!count) {
    return "";
  }else if (count === 1) {
    childYears = ""+childsInfo.get(0);
  } else {
    childYears = `${childsInfo.slice(0,childsInfo.size-1).join(', ')} ${i18n.t(separator)} ${childsInfo.get(childsInfo.size-1)}`;
  }

  const totalAge = childsInfo.reduce((prev, val)=> prev+val,0);

  return (childYears && `${childYears} ${i18n.t('_%año%_', !(totalAge === 1 && childsInfo.get(childsInfo.size-1) === 1) )}`) || "";

}

export const concatChildAgeSymbol = ({childsInfo, separator = " + "}) => {

  const i18n = contentGetter();
  if(!childsInfo?.size){
    return "";
  }

  return " ( "+ childsInfo.reduce((result, child)=>{
    return (result.push(`${child} ${i18n.t('_%año%_', child !== 1 )}`));
  },List()).join(separator) + " ) ";


}


export const getRoomName = ({childsInfo, adults, childs, babies, funcName = "default", separator })=>{


  const i18n = contentGetter();

  const childsAgeText = concatChildAgeText({childsInfo, separator});

  const totalChilds = childs+babies;

  return ' (' + adults + ' ' + i18n.t('_%adulto%_', adults !== 1) + (totalChilds > 0 ? (' + ' + totalChilds + ' ' + i18n.t('_%niño%_', totalChilds !== 1))+ (childsAgeText ? " - "+ childsAgeText : "") : '') + ')';
}

export const decodeBlackEmail = (emailB64, hotelId) => {
  //comprobacion por si aun no se recuperan ofuscados 
  // los emails al depender de caché
  if(emailB64.includes('@')) {
    return emailB64;
  }


  const $BLACKLIST_EMAIL_SECRET = 0x3ACB2; //Igual en HotelDescriptiveInfoAvail

  const number = hotelId ^ $BLACKLIST_EMAIL_SECRET;
  const bytes = atob(emailB64);
  let decoded = '';
  for (let i = 0; i < bytes.length; i++) {
    const charCode = bytes.charCodeAt(i) ^ (number % 256); 
    decoded += String.fromCharCode(charCode);
  }

  return decoded;
}